import { TypedUseSelectorHook, useSelector as originalUseSelector } from 'react-redux';
import IStore from './store.interface';

const useSelector: TypedUseSelectorHook<IStore> = originalUseSelector;

export default useSelector;
